import { CanDeactivateFn } from '@angular/router';

/** Una vista que puede preguntar antes de descartar cambios sin guardar. */
export interface LeaveConfirmable {
  confirmLeave(): boolean | Promise<boolean>;
}

/** Al salir de la ruta, la vista decide (p. ej. «Hay cambios sin guardar. ¿Salir?»). */
export const unsavedChangesGuard: CanDeactivateFn<LeaveConfirmable> = (component) =>
  component?.confirmLeave?.() ?? true;
